import { render, staticRenderFns } from "./bibliographyInf.vue?vue&type=template&id=d104a40c&scoped=true"
import script from "./bibliographyInf.vue?vue&type=script&lang=js"
export * from "./bibliographyInf.vue?vue&type=script&lang=js"
import style0 from "./bibliographyInf.vue?vue&type=style&index=0&id=d104a40c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d104a40c",
  null
  
)

export default component.exports